import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';
import { createEmptyCart, addProductToCart, getProducts } from './utils/graphql';
import { getMindboxPrices } from './utils/mindbox';

let cartQuantity = 0;

$.widget('sensibio.routine', {
	options: {
		selectors: {
			imagesSlider: '[data-role=images-slider]',
			productsSlider: '[data-role=products-slider]',
			slideCounter: '[data-role=slide-counter]',
			nextButton: '[data-role=button-next]',
			prevButton: '[data-role=button-prev]',
			pagination: '[data-role=pagination]',
			steps: '[data-role=tab]',
			addToCart: '[data-role=add-to-cart]',
			counter: '[data-role=cart-counter]',
			productName: '[data-role=product-name]',
			product: '[data-role=product]',
			productPrice: '[data-role=product-price]',
			regularPrice: '[data-role=regular-price]',
			oldPrice: '[data-role=old-price]',
			productImage: '[data-role=product-image]',
			productNotification: '[data-role=notification]',
			closeButton: '[data-role=close-button]',
		},
		classes: {
			active: '_active',
			show: '_show'
		},
	},

	_create() {
		this._pricesCache = {};
		this._bind();
	},

	_bind() {
		this._cache();
		this._events();
		this.initSliders();
		this.getProductsPrice();
	},

	_events() {
		this._on(this.$addTocart, {
			click: this.onAddToCartClick,
		});

		this._on(this.$closeButton, {
			click: this.onCloseButtonClick,
		});
	},

	_cache() {
		const { selectors } = this.options;

		this.$element = $(this.element);
		this.$imagesSliders = this.$element.find(selectors.imagesSlider);
		this.$productsSlider = this.$element.find(selectors.productsSlider);
		this.$steps = this.$element.find(selectors.steps);
		this.$addTocart = this.$element.find(selectors.addToCart);
		this.$counter = $(selectors.counter);
		this.$productName = $(selectors.productName);
		this.$productImage = $(selectors.productImage);
		this.$productNotification = $(selectors.productNotification);
		this.$productRegularPrice = this.$productNotification.find(selectors.regularPrice);
		this.$productOldPrice = this.$productNotification.find(selectors.oldPrice);
		this.$closeButton = $(selectors.closeButton);
	},

	initSliders() {
		this.$imagesSliders.each((_, container) => this.initImagesSlider(container));

		if ($(window).width() <= 1024) {
			this.initProductsSlider(this.$productsSlider);
		}
	},

	initImagesSlider(container) {
		const { selectors } = this.options;
		const $container = $(container);
		const loop = $container.data('loop') !== false;
		const isBannerSlider = $container.hasClass('sensibio-screen-second__slider');

		const updateSlideCounter = (swiper) => {
			const currentSlide = swiper.realIndex + 1;
			const $counterElement = $container.find(selectors.slideCounter);

			$counterElement.html(`
                <span class="_current">${currentSlide}</span><span class="_all">/${swiper.slides.length}</span>
            `);
		};

		const commonOptions = {
			modules: [Navigation],
			loop,
			spaceBetween: 12,
			pagination: {
				el: $container.find(selectors.pagination)[0],
				clickable: true,
			},
			on: {
				init: function () {
					updateSlideCounter(this);
				},
				slideChange: function () {
					updateSlideCounter(this);
				},
			},
		};

		if (isBannerSlider) {
			const swiper = new Swiper(container, {
				...commonOptions,
				slidesPerView: 'auto',
				navigation: false,
			});

			const $next = $container.find(selectors.nextButton);
			const $prev = $container.find(selectors.prevButton);

			const updateArrowsState = () => {
				$next.toggleClass('swiper-button-disabled', swiper.isEnd);
				$prev.toggleClass('swiper-button-disabled', swiper.isBeginning);
			};

			updateArrowsState();

			swiper.on('slideChange', updateArrowsState);

			$next.on('click', (event) => {
				event.preventDefault();
				swiper.slideTo(swiper.realIndex + 1);
			});

			$prev.on('click', (event) => {
				event.preventDefault();
				swiper.slideTo(swiper.realIndex - 1);
			});
		} else {
			new Swiper(container, {
				...commonOptions,
				slidesPerView: 'auto',
				navigation: {
					nextEl: $container.find(selectors.nextButton)[0],
					prevEl: $container.find(selectors.prevButton)[0],
				},
			});
		}
	},

	initProductsSlider(productsSliderSelector) {
		const $productsSlider = $(productsSliderSelector);

		const swiper = new Swiper($productsSlider[0], {
			modules: [Navigation],
			loop: false,
			autoHeight: true,
		});

		this._setupTabNavigation(swiper);
	},

	_setupTabNavigation(swiper) {
		const { selectors, classes } = this.options;

		const setActiveTab = (index) => {
			this.$steps.removeClass(classes.active);
			$(`${selectors.steps}[data-index=${index}]`).addClass(classes.active);
		};

		this.$steps.on('click', (event) => {
			const $element = $(event.currentTarget);
			const id = $element.data('index');

			swiper.slideTo(id);
		});

		swiper.on('activeIndexChange', () => {
			setActiveTab(swiper.realIndex);
		});
	},

	async onAddToCartClick(event) {
		const { classes, selectors } = this.options;
		const $product = $(event.currentTarget).closest(selectors.product);
		const sku = $(event.currentTarget).data('sku');
		const productName = $product.data('product-name');
		const productImage = $product.find('img').attr('src');
		const productRegularPrice = $product.find(selectors.regularPrice).text().slice(0, -1);
		const productOldPrice = $product.find(selectors.oldPrice).text().slice(0, -1);
		let quantity = $product.data('qty') || 0;

		event.preventDefault();

		// Получаем ID корзины из куки
		let cartId = document.cookie.match(/(?:^|;\s*)cart_id=([^;]*)/)?.[1];

		// Если нет в куки, создаем новую и устанавливаем
		if (!cartId) {
			cartId = await createEmptyCart();
			document.cookie = `cart_id=${cartId}; path=/; domain=${window.location.hostname}; SameSite=Lax; Secure`; 
		}

		quantity += 1;

		// Добавляем товар в корзину
		const result = await addProductToCart(cartId, sku, quantity);
		
		if (result.addSimpleProductsToCart) {
			cartQuantity += 1;
			$product.data('qty', quantity);
			this.$counter.text(cartQuantity);

			this.$productName.text(productName);
			this.$productImage.attr('src', productImage);
			this.$productOldPrice.text('');
			this.$productRegularPrice.text(productRegularPrice + ' руб.');

			if (productOldPrice) {
				this.$productOldPrice.text(productOldPrice + ' руб.');
			}

			this.$productNotification.addClass(classes.show);
		}
	},

	async getProductsPrice() {
		const { selectors } = this.options;
		const skus = [...new Set(this.$addTocart.map((_, button) => $(button).data('sku')).get())];

		if (!skus.length) {
			return;
		}

		const products = await getProducts(skus);
		const prices = await getMindboxPrices(products);

		this._pricesCache = prices;

		products.forEach((product) => {
			const priceInfo = prices[product.sku];
			const $button = $(`button[data-sku="${product.sku}"]`);

			if (!$button.length) {
				return;
			}

			if (product.stock_status === 'OUT_OF_STOCK') {
				$button.hide();
			}

			if (!priceInfo) {
				return;
			}

			const $regularPrice = $button.closest(selectors.product).find(selectors.regularPrice);
			const $oldPrice = $button.closest(selectors.product).find(selectors.oldPrice);
			const basePrice = priceInfo.basePrice;
			const finalPrice = priceInfo.finalPrice ?? priceInfo.basePrice;

			$regularPrice.html(`${finalPrice} ₽`);

			if (basePrice > finalPrice) {
				$oldPrice.html(`${basePrice} ₽`);
			}
		});
	},

	onCloseButtonClick() {
		this.$productNotification.removeClass(this.options.classes.show);
	}
});